import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './BenchmarkChart.css'
import {Row, Col} from 'react-flexbox-grid'
import {Bar} from 'react-chartjs'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import config from '../../config'
import { LinkIcon, XsBr } from '../'

@CSSModules(Styles, {allowMultiple:true})
export default class Chart extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {
      viewTooltipFootprint: false,
      viewTooltipIntensity: false,
      expandedBenchmarkSwitch: false
    }
  }

  getRisk = (val,label) => {
    const riskOptions = {
      low: {
        label: 'LOW',
        styleName: 'low',
        color: '#149A43'
      },
      avg: {
        label: 'BELOW MEDIAN',
        styleName: 'avg',
        color: '#AAD797'
      },
      high: {
        label: 'ABOVE MEDIAN',
        styleName: 'high',
        color: '#DFB553'
      },
      veryHigh: {
        label: 'HIGH',
        styleName: 'very-high',
        color: '#DE450A'
      },
      extreme: {
        label: 'VERY HIGH',
        styleName: 'extreme',
        color: '#C3001C'
      },
    }
    const f = convert.float(val)
    const ranges = config.footprintRanges[label]
    if (f <= ranges.low) {
      return riskOptions.low
    } else if (f <= ranges.avg) {
      return riskOptions.avg
    } else if (f <= ranges.high) {
      return riskOptions.high
    } else if (f <= ranges.veryHigh) {
      return riskOptions.veryHigh
    } else {
      return riskOptions.extreme
    }
  }

  clickViewTooltipFootprint = () =>{
    this.setState({viewTooltipFootprint: !this.state.viewTooltipFootprint})
  }
  clickViewTooltipIntensity = () =>{
    this.setState({viewTooltipIntensity: !this.state.viewTooltipIntensity})
  }
  clickExpandedBenchmarkSwitch = () =>{
    this.setState({expandedBenchmarkSwitch: !this.state.expandedBenchmarkSwitch})
  }
  clickCloseTooltips = () => {
    this.setState({
      viewTooltipFootprint: false,
      viewTooltipIntensity: false
    })
  }
  buildChartData = ( benchmarks, riskFootprint, riskIntensity ) => {
    const riskColorFootprint = riskFootprint.color
    const riskColorIntensity = riskIntensity.color
    const chartGray = '#D5D5D5'

    const datapoints = benchmarks.map((benchmark) => {
      return [
        chartGray,
        Math.round(convert.float(benchmark.footprint)),
        chartGray,
        Math.round(convert.float(benchmark.intensity)),
        benchmark.name
      ]
    })

    datapoints.push([
      riskColorFootprint,
      Math.round(convert.float(this.props.fund.usd_relative_footprint)),
      riskColorIntensity,
      Math.round(convert.float(this.props.fund.portfolio_carbon_carbon_intensity)),
      'This fund'
    ])

    // helper to sort
    function sortByIdx(array, idx) {
      return array.sort((a, b) => {
        return a[idx] - b[idx];
      });
    }
    const sortedByFootprint = sortByIdx(datapoints.slice(0), 1);
    const sortedByIntensity = sortByIdx(datapoints.slice(0), 3);

    // helper for unzipping
    function getFields(input, field) {
      const output = [];
      for (let i=0; i < input.length; ++i){
        output.push(input[i][field]);
      }
      return output;
    }

    // unzip sorted elements
    const colorsFootprint = getFields(sortedByFootprint, 0);
    const valuesFootprint = getFields(sortedByFootprint, 1);
    const labelsFootprint = getFields(sortedByFootprint, 4);

    const colorsIntensity = getFields(sortedByIntensity, 2);
    const valuesIntensity = getFields(sortedByIntensity, 3);
    const labelsIntensity = getFields(sortedByIntensity, 4);

    return {
      chartDataFoot : {
        labels: labelsFootprint,
        datasets: [{ label: 'Relative Carbon Footprint',
                     fillColor : colorsFootprint,
                     strokeColor : colorsFootprint,
                     highlightFill: colorsFootprint,
                     highlightStroke: colorsFootprint,
                     data: valuesFootprint}]
      },
      chartDataIntensity : {
        labels: labelsIntensity,
        datasets: [{ label: 'Relative Carbon Footprint',
                     fillColor : colorsIntensity,
                     strokeColor : colorsIntensity,
                     highlightFill: colorsIntensity,
                     highlightStroke: colorsIntensity,
                     data: valuesIntensity}]
      }
    }
  }

  render() {
    const _getRisk = this.getRisk

    const chartOptionsFoot = {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      scaleShowLabels: true,
      scaleShowGridLines: true,
      scaleShowVerticalLines: false,
      scaleShowHorizontalLines: true,
      showScale: true,
      scaleStartValue: 0,
    }

    const chartOptionsIntensity = {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      scaleShowLabels: true,
      scaleShowGridLines: true,
      scaleShowVerticalLines: false,
      scaleShowHorizontalLines: true,
      showScale: true,
      scaleStartValue: 0,
    }

    const riskFootprint = _getRisk(this.props.fund.usd_relative_footprint,'footprint')
    const riskIntensity = _getRisk(this.props.fund.portfolio_carbon_carbon_intensity,'intensity')

    const isExpanded = this.state.expandedBenchmarkSwitch

    const coreBenchmarksArray = config.coreBenchmarks
    const fullBenchmarksArray = config.coreBenchmarks.concat(config.extendedBenchmarks)

    function renderFootprintRisk(f){
      const risk = _getRisk(f, 'footprint')
      const riskLabel = risk.label
      const riskStyle = risk.styleName
      return(
        <span styleName={riskStyle}>
          <span>{riskLabel} compared to benchmarks</span>
        </span>
      )
    }
    function renderFootprintNumberbox(f){
      const risk = _getRisk(f, 'footprint')
      const riskStyle = risk.styleName
      return (
        <div styleName={'benchmark-chart-header-numberbox-'+riskStyle}>
          <div styleName='benchmark-chart-header-numberbox-header'>Relative carbon footprint</div>
          <div styleName={'benchmark-chart-header-numberbox-figure-'+riskStyle}>
            {format.number(f)}
          </div>
          <div styleName='benchmark-chart-header-numberbox-label'>tonnes CO<sub>2</sub> / $1M USD invested</div>
        </div>
      )
    }
    function renderIntensityRisk(f){
      const risk = _getRisk(f, 'intensity')
      const riskLabel = risk.label
      const riskStyle = risk.styleName
      return(
        <span styleName={riskStyle}>
          <span>{riskLabel} compared to benchmarks</span>
        </span>
      )
    }
    function renderIntensityNumberbox(f){
      const risk = _getRisk(f, 'intensity')
      const riskStyle = risk.styleName
      return (
        <div styleName={'benchmark-chart-header-numberbox-'+riskStyle}>
          <div styleName='benchmark-chart-header-numberbox-header'>Relative carbon intensity</div>
          <div styleName={'benchmark-chart-header-numberbox-figure-'+riskStyle}>
            {format.number(f)}
          </div>
          <div styleName='benchmark-chart-header-numberbox-label'>tonnes CO<sub>2</sub> / $1M USD revenue</div>
        </div>
      )
    }
    function renderBenchmarkTooltipText(label, plural){
      return (
        <div>
          Funds are compared to 20 of the most common investment indexes from major index providers like MSCI, FTSE/Russell, S&P, and Morningstar. Click the "Show all benchmarks" switch to show all 20 benchmarks in the charts below. Using iShares index ETFs as a stand-in for each index, we calculate the carbon {label} and divide the benchmarks into quartiles, labeled <strong styleName='low'>low</strong>, <strong styleName='avg'>below median</strong>, <strong styleName='high'>above median</strong>, and <strong styleName='very-high'>high</strong>. The carbon {label} of the fund is compared to these benchmark quartiles. If the {label} is higher than all 20 benchmarks, it is labeled <strong styleName='extreme'>very high</strong>. The benchmark quartiles are recalculated each month.
        </div>
      )
    }

    const footprintTableItems = [].concat(fullBenchmarksArray)
      .sort((a, b) => a.footprint - b.footprint)
      .map((item, idx) => {
        const risk = _getRisk(item.footprint,'footprint')
        const riskLabel = risk.label
        const riskStyle = risk.styleName
        return (<tr styleName='benchmark-tooltip-table-item' key={idx}>
          <td>{item.name}</td>
          <td styleName={riskStyle}>{format.number(item.footprint, true, true)} &mdash; {riskLabel}</td>
        </tr>)
      })

    const intensityTableItems = [].concat(fullBenchmarksArray)
      .sort((a, b) => a.intensity - b.intensity)
      .map((item, idx) => {
        const risk = _getRisk(item.intensity,'intensity')
        const riskLabel = risk.label
        const riskStyle = risk.styleName
        return (<tr styleName='benchmark-tooltip-table-item' key={idx}>
          <td>{item.name}</td>
          <td styleName={riskStyle}>{format.number(item.intensity, true, true)} &mdash; {riskLabel}</td>
        </tr>)
      })

    return (
      <div styleName='benchmark-wrap'>
        <div styleName='benchmark-wrap-inner'>
          { /*
            config.footprintDate ?
              (
                <div styleName='foot-date-disc'>
                  Carbon footprint calculated {config.footprintDate}
                </div>
              ) :
              null
          */ }
          <Row>
            <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>
              { renderFootprintNumberbox(this.props.fund.usd_relative_footprint) }
            </Col>
            <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>
              <div styleName='benchmark-chart-header'>
                <div styleName='benchmark-chart-header-info'>
                  <div styleName='benchmark-chart-title'>
                    Carbon footprint <XsBr /><small><i>emissions per unit of investment</i></small>
                  </div>
                  <div styleName='benchmark-chart-subtitle'>
                    { renderFootprintRisk(this.props.fund.usd_relative_footprint) }
                  </div>
                  <div styleName='benchmark-chart-info'>
                    Expresses the greenhouse gas footprint of an investment sum. Relative carbon footprint is measured in metric tonnes of CO<sub>2</sub> or CO<sub>2</sub> equivalents per $1 million USD invested. A fund's carbon footprint accounts for direct and indirect (scope 1 and 2) emissions.
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={0} sm={1} />
            <Col xs={12} sm={10}>

              <div styleName='benchmark-chart-options'>
                <div
                  styleName='benchmark-chart-notice'
                  onClick={this.clickViewTooltipFootprint}
                  title='How do we compare funds to benchmarks?'>
                  <i className='fa fa-question-circle'/> How do we compare funds to benchmarks?
                </div>
                <div
                  styleName='benchmark-chart-switch'
                  onClick={this.clickExpandedBenchmarkSwitch}
                  title='Show all benchmarks switch'>
                  Show all benchmarks&nbsp;

                  {(isExpanded)
                    ?(<i className='fa fa-toggle-on fa-2x'/>)
                    :(<i className='fa fa-toggle-off fa-2x'/>)
                  }

                </div>
              </div>

              {
                (this.state.viewTooltipFootprint)?(
                  <div styleName='benchmark-chart-tooltip-wrap'>
                    <div styleName='benchmark-chart-tooltip-wrap-inner'>
                      <div styleName='benchmark-chart-tooltip'>
                        <div styleName='benchmark-tooltip-close' title='Close'
                          onClick={this.clickViewTooltipFootprint}>
                          Close
                          <LinkIcon faclass='fa-times'/>
                        </div>
                        { renderBenchmarkTooltipText('footprint','footprints') }
                        <table styleName='benchmark-tooltip-table'>
                          { footprintTableItems }
                          <tr styleName={'benchmark-tooltip-table-item benchmark-tooltip-table-last'}>
                            <td>
                              THIS FUND: {this.props.fund.fund_legal_name}
                            </td>
                            <td styleName={riskFootprint.styleName}>
                              {format.number(this.props.fund.usd_relative_footprint, true, true)} &mdash; {riskFootprint.label}
                            </td>
                          </tr>
                        </table>
                        <span>Relative carbon footprint is measured in metric tonnes of CO<sub>2</sub> or CO<sub>2</sub> equivalents per $1 million USD invested, Scope 1 + 2</span>
                      </div>
                    </div>
                  </div>
                ):null
              }

              <div styleName='benchmark-chart-chart-wrap'>
                <div styleName='benchmark-chart-chart'>

                  {(isExpanded)
                    ?(<Bar
                        data={this.buildChartData(fullBenchmarksArray, riskFootprint, riskIntensity).chartDataFoot}
                        options={chartOptionsFoot}/>)
                    :null
                  }

                  {(!isExpanded)
                    ?(<Bar
                        data={this.buildChartData(coreBenchmarksArray, riskFootprint, riskIntensity).chartDataFoot}
                        options={chartOptionsFoot}/>)
                    :null
                  }

                </div>
              </div>
            </Col>
            <Col xs={0} sm={1} />
          </Row>

          <Row styleName='intensity-row'>
            <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>

              { renderIntensityNumberbox(this.props.fund.portfolio_carbon_carbon_intensity) }

            </Col>
            <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>
              <div styleName='benchmark-chart-header'>
                <div styleName='benchmark-chart-header-info'>
                  <div styleName='benchmark-chart-title'>
                    Carbon intensity <XsBr /><small><i>emissions per unit of revenue</i></small>
                  </div>
                  <div styleName='benchmark-chart-subtitle'>
                    { renderIntensityRisk(this.props.fund.portfolio_carbon_carbon_intensity) }
                  </div>
                  <div styleName='benchmark-chart-info'>
                    Expresses the carbon efficiency of a portfolio. Relative carbon intensity is measured in metric tonnes of CO<sub>2</sub> or CO<sub>2</sub> equivalents per $1 million USD revenue. A fund's carbon intensity accounts for direct and indirect (scope 1 and 2) emissions.
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={0} sm={1} />
            <Col xs={12} sm={10}>

              <div styleName='benchmark-chart-options'>
                <div
                  styleName='benchmark-chart-notice'
                  onClick={this.clickViewTooltipIntensity}
                  title='How do we compare funds to benchmarks?'>
                <i className='fa fa-question-circle'/> How do we compare funds to benchmarks?
                </div>
                <div
                  styleName='benchmark-chart-switch'
                  onClick={this.clickExpandedBenchmarkSwitch}
                  title='Show all benchmarks switch'>
                  Show all benchmarks&nbsp;

                  {(isExpanded)
                    ? (<i className='fa fa-toggle-on fa-2x'/>)
                    : (<i className='fa fa-toggle-off fa-2x'/>)
                  }

                </div>
              </div>

              {
                (this.state.viewTooltipIntensity)?(
                  <div styleName='benchmark-chart-tooltip-wrap'>
                    <div styleName='benchmark-chart-tooltip-wrap-inner'>
                      <div styleName='benchmark-chart-tooltip'>
                        <div styleName='benchmark-tooltip-close'
                          onClick={this.clickViewTooltipIntensity} title='Close'>
                          Close
                          <LinkIcon faclass='fa-times'/>
                        </div>
                        { renderBenchmarkTooltipText('intensity','intensities') }
                        <table styleName='benchmark-tooltip-table'>

                          { intensityTableItems }

                          <tr styleName={'benchmark-tooltip-table-item benchmark-tooltip-table-last'}>
                            <td>
                              THIS FUND: {this.props.fund.fund_legal_name}
                            </td>
                            <td styleName={riskIntensity.styleName}>
                              {format.number(this.props.fund.portfolio_carbon_carbon_intensity, true, true)} &mdash; {riskIntensity.label}
                            </td>
                          </tr>
                        </table>
                        <span>Relative carbon intensity is measured in metric tonnes of CO<sub>2</sub> or CO<sub>2</sub> equivalents per $1 million USD revenue, Scope 1 + 2</span>
                        <div styleName='benchmark-tooltip-close'
                          onClick={this.clickViewTooltipIntensity} title='Close'>
                          Close
                          <LinkIcon faclass='fa-times'/>
                        </div>
                      </div>
                    </div>
                  </div>
                ):null
              }

              <div styleName='benchmark-chart-chart-wrap'>
                <div styleName='benchmark-chart-chart'>

                  {(isExpanded)
                    ?(<Bar
                        data={this.buildChartData(fullBenchmarksArray, riskFootprint, riskIntensity).chartDataIntensity}
                        options={chartOptionsIntensity}/>)
                    :null
                  }

                  {(!isExpanded)
                    ?(<Bar
                        data={this.buildChartData(coreBenchmarksArray, riskFootprint, riskIntensity).chartDataIntensity}
                        options={chartOptionsIntensity}/>)
                    :null
                  }

                </div>
              </div>
            </Col>
            <Col xs={0} sm={1} />
          </Row>

        </div>

        { (this.state.viewTooltipFootprint || this.state.viewTooltipIntensity)
            ? (<div styleName='tooltip-overlay' onClick={this.clickCloseTooltips}/>)
            : null }

      </div>
    )
  }
}

